import React from 'react'
import Spinner from 'react-spinkit'

const fallbackStyles = {
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  spinner: {
    position: 'absolute',
    top: '45%',
    left: '50%',
    zIndex: 3000,
  },
}

const mergeStyleObjects = (baseStyles, propStyles) => (
  Object.keys(baseStyles).reduce((merged, styleKey) => {
    if (!propStyles.hasOwnProperty(styleKey)) {
      merged[styleKey] = { ...baseStyles[styleKey] }
    } else {
      merged[styleKey] = {
        ...baseStyles[styleKey],
        ...propStyles[styleKey],
      }
    }

    return merged
  }, {})
)

const Loading = (props) => {
  const styles = mergeStyleObjects(fallbackStyles, props.style)
  return (
    <div
      className="loading-icon"
      style={styles.wrapper}
    >
      <Spinner
        spinnerName="cube-grid"
        style={styles.spinner}
      />
    </div>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/sitewide/Loading.js